import {
  ApiBlueprint,
  PageBlueprint,
  createApiFactory,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import { discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { techRadarAoeApiRef, TechRadarAoeApiClient } from './api/TechRadarAoeApi';

export const techRadarAoeRouteRef = createRouteRef();

const techRadarAoeApi = ApiBlueprint.make({
  name: 'tech-radar-aoe',
  params: define =>
    define(
      createApiFactory({
        api: techRadarAoeApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
        },
        factory: ({ discoveryApi, fetchApi }) =>
          new TechRadarAoeApiClient({ discoveryApi, fetchApi }),
      }),
    ),
});

const techRadarAoePage = PageBlueprint.make({
  params: {
    path: '/tech-radar',
    noHeader: true,
    routeRef: techRadarAoeRouteRef,
    loader: () =>
      import('./components/TechRadarAoeRouter').then(
        ({ TechRadarAoeRouter }) => <TechRadarAoeRouter />,
      ),
  },
});

export default createFrontendPlugin({
  pluginId: 'tech-radar-aoe',
  extensions: [techRadarAoeApi, techRadarAoePage],
});
